<script setup lang="ts">
import { ChevronRight, User } from "@/components/icons";
import { useAuthStore } from "@/stores/authStore";
import { getUserValue } from "@/lib/auth";
import {
  PopoverAnchor,
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
} from "reka-ui";

const authStore = useAuthStore();
</script>

<template>
  <PopoverRoot v-if="authStore.user">
    <PopoverAnchor>
      <PopoverTrigger
        class="bg-background-brand text-icon-white w-12 h-12 rounded-xl flex-center relative z-10 cursor-pointer"
      >
        <User size="38" />
      </PopoverTrigger>
    </PopoverAnchor>
    <PopoverPortal>
      <PopoverContent
        class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 min-w-60 max-w-80 z-20"
        align="end"
        :sideOffset="5"
      >
        <div
          class="bg-background-primary border border-border-primary shadow-card p-4 rounded-xl"
        >
          <div
            v-if="authStore.user"
            class="flex flex-col justify-center h-12 mb-4 whitespace-nowrap"
          >
            <p class="overflow-hidden text-ellipsis">
              {{ getUserValue(authStore.user, "firstname") }}
              {{ getUserValue(authStore.user, "lastname") }}
            </p>
            <p class="text-sm opacity-60 overflow-hidden text-ellipsis">
              {{ authStore.user.remote_human_id }}
            </p>
          </div>
          <div class="py-4 border-t border-b border-border-primary mb-4">
            <ul>
              <li>
                <RouterLink to="/account" class="account-menu-item">
                  <span>{{ $t("account_menu.personal_info") }}</span>
                  <ChevronRight size="16" />
                </RouterLink>
              </li>
            </ul>
          </div>
          <div>
            <button type="button" @click="authStore.showLogoutModal = true">
              {{ $t("common.logout") }}
            </button>
          </div>
        </div>
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
  <div v-else>
    <button class="btn-primary" @click="authStore.showLoginModal = true">
      {{ $t("common.sign_in") }}
    </button>
  </div>
</template>
